/* eslint-disable */
import React from "react";
import HomeTop from "./HomeTop/HomeTop";
import ListOfPost from "./ListOfPost/ListOfPost";
import { home_top } from "./../../Store/action/HomeAction";
import { connect } from "react-redux";
import { loadProgressBar } from "axios-progress-bar";
import "../../../node_modules/axios-progress-bar/dist/nprogress.css";
import { story_category } from "./../../Store/action/StoryAction";
import HomeMobHeader from "../Header/Home_Mob_Header";
import "../../Styles/Home.css";
import ReactGA from "react-ga";
import Helmet from "react-helmet";
import Home_Header from "../Header/Home_Header";
import Contests from "./Contests";
import Axios from "axios";

var load = false;
var metatags_names = [];
var metatags_props = [];
var data = [];

class Home extends React.Component {
  constructor(props) {
    super(props);

    if (localStorage.getItem("other_user_slug")) {
      var user_slug = localStorage.getItem("other_user_slug");
      localStorage.removeItem("other_user_slug");

      this.props.history.push("/" + user_slug);
    }

    // this.props.story_category();
    this.container = React.createRef();
    this.state = {
      data: {},
      load: false,
      scrollableHeader: false,
      fixedHeader: false,
      show_loader: true,
      progress: 0,
      dialog_login: false,
      meta: false,
      home: false,
    };
    ReactGA.initialize("UA-117934873-2", {
      gaOptions: {
        userId: JSON.parse(localStorage.getItem("current_user"))
          ? JSON.parse(localStorage.getItem("current_user")).displayName +
            "_" +
            JSON.parse(localStorage.getItem("current_user")).id
          : "Guest_User",
      },
    });
    ReactGA.pageview(window.location.pathname + window.location.search);
    localStorage.setItem('page', true)
  }

  componentDidMount() {
    if (this.props.load) {
    } else {
    }
    this.getHomePage();
    load = true;
  }

  // Home Page All Components
  getHomePage = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.user,
    };

    Axios.get(
      "https://wallmag-2.appspot.com/_ah/api/userApi/v1/startUpCallWeb",
      headers
    )
      .then((res) => {
        data = res.data;
        // metatags = res.data.metaTags
        this.setState({
          home: true,
        });

        metatags_names = Object.entries(res.data.metaTags.names);
        metatags_props = Object.entries(res.data.metaTags.properties);

        this.setState({
          home: true,
        });

        //console.log(metatags_names.keys);
      })
      .catch((error) => {
        //console.log(error.message);
      });
  };

  // Login Dialog open
  openLogin = (e) => {
    e.preventDefault();
    this.setState({
      dialog_login: true,
    });
  };

  // Login Dialog close
  closeLogin = (e) => {
    e.preventDefault();
    this.setState({
      dialog_login: false,
    });
  };

  // go To Mission
  goToMission = (e) => {
    e.preventDefault();

    this.props.history.push("/missions/weddingraphy2019");
  };

  render() {

    return (
      <div style={{ background: "white" }}>
        {this.state.home === true ? (
             
             <Helmet>
               
             {metatags_names.map((res) => {
               return (
                 <meta name={res[0]} content={res[1]} />
               );
             })}
             
             {
                 metatags_names.map((res)=>{
                     return res[0] === "title" ? (
                         <title>{res[1]}</title>
                       ) : ''
                 })
             }
 
             {metatags_props.map((res) => {
               return <meta property={res[0]} content={res[1]} />;
             })}
           </Helmet>
                
 
        ) : (
          <></>
        )}

        {/* Progress Bar */}
        {loadProgressBar()}

        <div>
          {/* Header of the website */}
          <div className="mob_top">
            <HomeMobHeader />
          </div>

          <div className="web_top">
            <Home_Header />
          </div>

          {/* Top 4 Articles (Featured Articles)  */}
          {/* <div style={{overflow: "hidden" , width: "100%"}}>
                <HomeTop data={this.props.story_category_data} />      
            </div>  */}

          {/* <div
      style= {{backgroundImage:`linear-gradient( to top , rgba(0,0,0,.5),
    transparent),linear-gradient( to bottom , rgba(0,0,0,1), transparent)
    , url(${require('../../logo/wedding.jpg')})`,
    // marginTop:'60px' ,
        height:'560px' , width:'100%' , backgroundSize:'cover' , backgroundPosition:'center center' , backgroundRepeat : 'no-repeat' }}
 className='container-fluid' >
            <div className='row' style={{ marginBottom:'-48px', height:'550px', alignContent:'center', justifyContent:'center'}}>
           
                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                  <p className='wpa'>Wedding Photography Awards</p>
                </div>  
                
                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                  <p className='wpa_desc'>29 States, one Image. More than 1 Lakh in prizes</p>
                </div>

              <button onClick={e=>this.goToMission(e)} className="participate_btn" style={{outline:'none'}}>
          

                Participate
              </button> 

        </div>
        </div>
  */}

          {/* {this.state.home === false ? (
            <></>
          ) : ( */}
            <div>
              {
                data.missions ? 
                <>
                 <div className="container rs_div">
             <div className="row justify-content-center">
              <p id="featuredstories2">Photography Awards</p>
            </div>
            </div>   
                <Contests data={data.missions} />
                
                </> : ''
              }
              
              

              {load === true ? (
                <div>
                  {/*         
        <div>
            <Category clr='white' clrTxt='black'/>
        </div>  */}

                  {/* /List Of Posts */}
                  {data.stories ? (
                    <div>
                   
                   <ListOfPost  props={this.props} data={data}/>



                      {/* <ListOfPost
                        props={data.stories}
                        catData={data.categories}
                      /> */}
                    </div>
                  ) : (
                    ""
                  )}

                  {/* <div className='extra_space_div'>

           </div>  */}
                </div>
              ) : (
                <></>
              )}
            </div>
        

          <nav>
            <div>
              <div></div>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    story_category_data: state.story_cat.story_category,
    load: state.story_cat.load,

    // this is  for condition of load before another compoo
    home_top_load: state.home.home_top_load,
  };
};
export default connect(mapStateToProps, { home_top, story_category })(Home);
